module.exports = {"id":"197083","name":"Daniel Caligiuri","rating":"79","photo":"./data/images/photos/3/197083.png","club":{"name":"FC Schalke 04","logo":"./data/images/clubs/FCSchalke04.png"},"positions":["MD","DLD","AD","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanielCaligiuri0.json
// module id = 926
// module chunks = 0